import selectionUtils from 'utils/selectionUtils';

const themeCommandsToReset = [
    'fontSize',
    'bold',
    'unBold',
    'italic',
    'unItalic',
    'fontFamily',
    'foreColor',
    'fontWeight',
    'lineHeight',
    'letterSpacing'
];
const resetStyleName = [
    'font-family',
    'font-weight',
    'font-size',
    'font-style',
    'color',
    'line-height',
    'letter-spacing'
];
export default {
    exec: function (editor) {
        editor.undoManager.lock(true);
        selectionUtils.enlargeSelectionToBlock(editor);

        themeCommandsToReset.forEach(commandName => {
            const command = editor.getCommand(commandName);
            if (command.style) {
                editor.removeStyle(command.style);
            } else {
                command.exec(CKEDITOR.TRISTATE_OFF);
            }
        });
        selectionUtils.getSelectedLists(editor).forEach(element => {
            resetStyleName.forEach(styleName => {
                element.removeStyle(styleName);
            });
        });

        editor.fire('change');
        editor.undoManager.unlock();
    },
    canUndo: false
};
